import React from 'react'
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native'
import { useTheme } from '@/contexts/ThemeContext'
import { useRouter } from 'expo-router'

export default function BlogCTA() {
  const { colors } = useTheme()
  const router = useRouter()

  const styles = StyleSheet.create({
    container: {
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: 12,
      paddingVertical: 20,
      paddingHorizontal: 16,
      backgroundColor: colors.surface,
      alignItems: 'center',
      gap: 8,
      marginTop: 24,
    },
    title: {
      fontSize: 18,
      fontFamily: 'Inter-SemiBold',
      color: colors.text,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: 14,
      fontFamily: 'Inter-Regular',
      color: colors.textSecondary,
      textAlign: 'center',
    },
    button: {
      marginTop: 12,
      paddingVertical: 12,
      paddingHorizontal: 24,
      borderRadius: 20,
      backgroundColor: colors.primary,
    },
    buttonText: {
      fontSize: 16,
      fontFamily: 'Inter-SemiBold',
      color: '#FFFFFF',
    },
  })

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Gostou da dica?</Text>
      <Text style={styles.subtitle}>
        Registre-se no Põe no Racha e facilite sua vida.
      </Text>
      <TouchableOpacity
        onPress={() => router.push('/(auth)/register')}
        style={styles.button}
        activeOpacity={0.8}
      >
        <Text style={styles.buttonText}>Registre-se</Text>
      </TouchableOpacity>
    </View>
  )
}
